import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "standard option" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = ["value", "checked", "onChange"]
const _hoisted_4 = { class: "standard option" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = ["value", "checked", "onChange"]
const _hoisted_7 = { class: "standard option" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = ["value", "checked", "onChange"]
const _hoisted_10 = { class: "center-wrapper" }
const _hoisted_11 = { class: "mobile-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_EasyMultiRangeSlider = _resolveComponent("EasyMultiRangeSlider")!

  return (_openBlock(), _createBlock(_component_EasyDrop, {
    hasTopTip: true,
    position: 'center',
    customClasses: 'flight-filter',
    customButtonClasses: 'filter-btn',
    isFullMobile: true,
    ref: "easyDrop"
  }, _createSlots({
    buttonText: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterButtonText']), 1)
    ]),
    contentHeader: _withCtx(() => [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterSubHeadline']), 1)
      ])
    ]),
    contentFooter: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
        }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonSave']), 1),
        _createElementVNode("button", {
          type: "button",
          class: "link-btn",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetAllFilters && _ctx.resetAllFilters(...args)))
        }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonReset']), 1)
      ])
    ]),
    _: 2
  }, [
    (_ctx.filters)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("form", null, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelMaxStops']), 1),
                _createVNode(_component_EasyDrop, {
                  customClasses: 'standard',
                  dropdownType: 'select'
                }, {
                  buttonText: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.maxStopSelected().name) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("label", _hoisted_1, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "maxStops",
                        value: "all",
                        checked: _ctx.isAllStopsSelected,
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetMaxStops && _ctx.resetMaxStops(...args)))
                      }, null, 40, _hoisted_2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownAll']) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedFilters.maxStops, (stop, index) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: "standard option",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "maxStops",
                          value: stop.id,
                          checked: stop.isSelected,
                          onChange: ($event: any) => (_ctx.updateMaxStops(stop))
                        }, null, 40, _hoisted_3),
                        _createElementVNode("span", null, _toDisplayString(stop.name) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelAirlines']), 1),
                _createVNode(_component_EasyDrop, {
                  customClasses: 'standard',
                  dropdownType: 'select'
                }, {
                  buttonText: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedAirlinesCount() > 0 ? _ctx.selectedAirlinesCount() + " " +
                                    _ctx.pageTexts['hotelPageFlightStepFilterSelected'] :
                                    _ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownAll']), 1)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("label", _hoisted_4, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        name: "selectedAirlines",
                        value: "all",
                        checked: _ctx.isAllAirlinesSelected,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetAirlines && _ctx.resetAirlines(...args)))
                      }, null, 8, _hoisted_5),
                      _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownAll']), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedFilters.airlines, (airline, index) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: "standard",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          name: "selectedAirlines",
                          value: airline.id,
                          checked: airline.isSelected,
                          onChange: ($event: any) => (_ctx.updateAirline($event, index))
                        }, null, 40, _hoisted_6),
                        _createElementVNode("span", null, _toDisplayString(airline.name), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelTravelClass']), 1),
                _createVNode(_component_EasyDrop, {
                  customClasses: 'standard',
                  dropdownType: 'select'
                }, {
                  buttonText: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedTravelClassCount() > 0 ? _ctx.selectedTravelClassCount() + " " +
                                    _ctx.pageTexts['hotelPageFlightStepFilterSelected'] :
                                    _ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownAll']), 1)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("label", _hoisted_7, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        name: "travelClass",
                        value: "all",
                        checked: _ctx.selectedTravelClassCount() <= 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetTravelClass($event)))
                      }, null, 8, _hoisted_8),
                      _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownAll']), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedFilters.travelClass, (travelClass, index) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: "standard",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          name: "travelClass",
                          value: travelClass.id,
                          checked: travelClass.isSelected,
                          onChange: ($event: any) => (_ctx.updateTravelClass($event, index))
                        }, null, 40, _hoisted_9),
                        _createElementVNode("span", null, _toDisplayString(travelClass.name), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_EasyMultiRangeSlider, {
                label: _ctx.pageTexts['hotelPageFlightStepFilterPopupLabelTravelLength'],
                minValue: _ctx.computedFilters.minSliderValue,
                maxValue: _ctx.computedFilters.maxSliderValue,
                maxValueAvailable: _ctx.computedFilters.maxSliderValueAvailable,
                minValueAvailable: _ctx.computedFilters.minSliderValueAvailable,
                step: 1,
                "input-postfix": _ctx.pageTexts['hotelPageFlightStepFilterPopupLabelHours'],
                minId: 'flightMinTime',
                maxId: 'flightMaxTime',
                minLabel: _ctx.pageTexts['hotelPageFlightStepFilterPopupLabelMin'],
                maxLabel: _ctx.pageTexts['hotelPageFlightStepFilterPopupLabelMax'],
                localeStrings: _ctx.localeStrings,
                onMaxValueupdate: _ctx.updateMaxTravelLength,
                onMinValueUpdate: _ctx.updateMinTravelLength,
                onSliderUpdate: _ctx.UpdateTravelLength
              }, null, 8, ["label", "minValue", "maxValue", "maxValueAvailable", "minValueAvailable", "input-postfix", "minLabel", "maxLabel", "localeStrings", "onMaxValueupdate", "onMinValueUpdate", "onSliderUpdate"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-secondary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetAllFilters && _ctx.resetAllFilters(...args)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonReset']), 1)
            ])
          ])
        }
      : undefined
  ]), 1536))
}